import React from 'react'
import Cdata from '../data/Cdata'
function Pack() {
  return (
    <>
    <div className='packup py-5'>
    <div className='container pt-5'>
      <div className='row justify-content-center'>
            <div className='col-lg-8'>
            <div className='popular py-5 text-center'>
          <p className='fs-6 fw-semibold text-secondary best'>GET READY.</p>
          <h2 className='fs-1 fw-bold py-2'>Pack Up and Go</h2>
          <p className='fs-6 fw-normal'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi posuere tempor mauris, nec imperdiet mi rutrum eget. Donec quis ligula in tellus dictum consequat.</p>
          </div>
            </div>
        </div>
        <div className='row pt-5'>
      {Cdata.map((a)=>(
        <div className='col-lg-4'>
        <div className='card my-3'>
          <img className='w-100' src={a.image}/>
          <div className='card-body'>
          <h5 className='fw-normal pt-4 pb-2'>{a.description}</h5>
          <div className='d-flex text-secondary'>
          <i class="bi bi-globe fs-6"></i>
          <p className='ps-2'>{a.title}</p>
          </div>
            <hr/>
          <div className='d-flex pt-0 pb-2'>
          <h5 className='fw-semibold'>${a.price}</h5>
          <button type="button" class="btn ms-auto book px-4 py-2">Book Now</button>
          </div>
          
          </div>
        </div>
       </div>
      
      ))}
      </div>
    </div>
    </div>
    <div className='container py-5'>
      <div className='row'>
        <div className='col-lg-6'>
          <div className='me-3 border p-5 text-center mt-5 mari'>
          <p className='lh-base text-secondary'>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum.</p>
          <img className='py-3' width={100} src={require('../image/h1.png')}/>
          <h5 className='fw-bold'>Marianna Loreto</h5>
          </div>
        </div>
        <div className='col-lg-6'>
          <div className='border p-5 text-center mt-5 mari'>
          <p className='lh-base text-secondary'>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum.</p>
          <img className='py-3' width={100} src={require('../image/h2.png')}/>
          <h5 className='fw-bold'>Robert Hellison</h5>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Pack
